import {Injectable, Injector} from "@angular/core";
import {SearchModel} from "@fedeltapointofsale/data-client";

@Injectable()
export class CustomObjectSearchModel extends SearchModel<any> {
    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "customObjectId";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }

    override getResourceName(): string {
        return "custom-object";
    }

    override getResource(): string {
        return "custom-group";
    }
}
